const DAY_MS = 24 * 60 * 60 * 1000;

// Dates arrive either as ISO strings or as epoch-ms numbers/strings, depending
// on which resolver serialized them.
export const parseDate = (value?: string | number | null) => {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(value);
  const date = new Date(Number.isNaN(numeric) ? value : numeric);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value?: string | number | null) =>
  parseDate(value)?.toLocaleDateString() ?? "—";

export const timeAgo = (value?: string | number | null) => {
  const date = parseDate(value);
  if (!date) return "—";
  const days = Math.floor((Date.now() - date.getTime()) / DAY_MS);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.floor(days / 30)} mo ago`;
  return `${Math.floor(days / 365)} yr ago`;
};

// Chaturbate pays broadcasters $0.05 per token.
export const tokensToDollars = (tokens: number) =>
  `$${Math.round(tokens * 0.05).toLocaleString()}`;
